export default {
  id: 2,
  title: 'Target #2 - Carrom',
  url: 'https://cssbattle.dev/play/2',
  colors: ['#62374e', '#fdc57b'],
  solution:
    '<p><style>body{margin:0;background:#62374e}p{background:#fdc57b;width:50;height:50;margin:50 0 0 50;box-shadow:0 150px #fdc57b,250px 150px #fdc57b,250px 0 #fdc57b}</style>',
}
